export default __webpack_public_path__ + "static/media/domestic transfer-01.9fcde676.svg";